import React, { useEffect, useMemo, useState } from 'react';
import { initialsFromName, resolveAvatarUrl, resolveDisplayName } from '../utils/telegramUser';

const Avatar = ({ userData, size = 44, className = '' }) => {
  const [broken, setBroken] = useState(false);
  const name = useMemo(() => resolveDisplayName(userData), [userData]);
  const src = useMemo(() => resolveAvatarUrl(userData), [userData]);

  useEffect(() => {
    setBroken(false);
  }, [src]);

  const showImg = Boolean(src) && !broken;

  return (
    <div
      className={`avatar ${className}`}
      style={{ width: size, height: size, minWidth: size }}
      aria-label={name}
    >
      {showImg ? (
        <img
          key={src}
          src={src}
          alt=""
          className="avatar-img"
          loading="eager"
          decoding="async"
          // Same-origin /media avatars need no special referrer; keep no-referrer
          // for leftover Telegram CDN URLs so desktop still works.
          referrerPolicy="no-referrer"
          onError={() => setBroken(true)}
        />
      ) : (
        <span className="avatar-fallback">{initialsFromName(name)}</span>
      )}
      <span className="avatar-ring" aria-hidden />
    </div>
  );
};

export default Avatar;
